
























































































































































import PageHeader from "@/components/PageHeader.vue";
import { Component, Mixins } from "vue-property-decorator";
// eslint-disable-next-line no-unused-vars
import { Domain } from "@/types/domain";
import { DomainHttp } from "@/mixins/http/domain";
import { toDomain } from "@/utils";
import ConfirmDeleteDialog from "@/components/ConfirmDeleteDialog.vue";
import PageBody from "@/components/PageBody.vue";
import { HttpErrorHandler } from "@/mixins/error-handling";
import DateUtils from "@/utils/dayjs";

@Component({
	components: {
		"page-header": PageHeader,
		"confirm-delete-dialog": ConfirmDeleteDialog,
		"page-body": PageBody,
	},
})
export default class DomainDetail extends Mixins(DomainHttp, HttpErrorHandler, DateUtils) {
	domain: Domain | null = null;
	public showConfirmDelete: boolean = false;
	showCopiedToClipboard: boolean = false;

	fab: boolean = false;
	mounted() {
		let domainId: string = this.$router.currentRoute.params["id"];
		this.getDomainByIdFromApi(domainId);
	}

	getDomainByIdFromApi(id: string) {
		this.getDomainById(id)
			.then((apiResponse) => {
				let converted = toDomain(apiResponse.data);
				if (converted) this.domain = converted;
			})
			.catch((error: any) => this.handleTokenExpired(error.response.data.message));
	}

	private deleteDomainFromApi(): void {
		this.deleteDomain(this.domain!)
			.then(() => {
				this.$router.push("/domains");
			})
			.catch((error: any) => this.handleTokenExpired(error.response.data.message));
	}

	copyElementById(id: string): void {
		let copyText: any = document.getElementById(id);
		let textArea = document.createElement("textarea");
		textArea.value = copyText.textContent;
		document.body.appendChild(textArea);
		textArea.select();
		document.execCommand("Copy");
		textArea.remove();
		this.showCopiedToClipboard = true;
	}

	capitalizeFirstLetter(text: string): string {
		let firstLetter: string = text.charAt(0).toUpperCase();

		return firstLetter + text.slice(1, undefined);
	}
}
